import PropTypes from 'prop-types';

import SignReceiptCommandBar from './SignReceiptCommandBar';
import SignReceiptDetailSection from './SignReceiptDetailSection';
import SignReceiptMainInfoCard from './SignReceiptMainInfoCard';

const SignReceiptBlock = ({
  detail,
  defaultOpen = true,
  onRefetch,
  showActions = false,
}) => (
  <div className="receipt-card-elevate">
    <div className="receipt-card-surface">
      <SignReceiptMainInfoCard
        detail={detail}
        embedded
        actions={
          showActions ? (
            <SignReceiptCommandBar
              key={`${detail.id}-${detail.record?.updatedAt ?? ''}`}
              detail={detail}
              onRefetch={onRefetch}
            />
          ) : null
        }
      />
      <SignReceiptDetailSection detail={detail} embedded defaultOpen={defaultOpen} />
    </div>
  </div>
);

SignReceiptBlock.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    signReceiptNo: PropTypes.string,
    status: PropTypes.string,
    record: PropTypes.shape({
      updatedAt: PropTypes.string,
    }),
    lines: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  defaultOpen: PropTypes.bool,
  onRefetch: PropTypes.func,
  showActions: PropTypes.bool,
};

export default SignReceiptBlock;
